import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M32.87 7.05a.844.844 0 0 1 1.08 1.08L24.97 33l-.028.065a1.604 1.604 0 0 1-2.903.025l-4.71-9.42-9.42-4.71a1.603 1.603 0 0 1-.655-2.311l.066-.094A1.6 1.6 0 0 1 8 16.03zM18.985 23.208l4.486 8.971 7.606-21.064zm-10.166-5.68 8.973 4.486L29.884 9.922z" }, null, -1)
  ]))]))
}
export default { render: render }